import { useEffect, useContext } from "react";
import { makeStyles } from "@material-ui/core/styles";
import { Grid, Button, Paper } from "@material-ui/core";
import Spacer from "../../components/Spacer";
import MainContainer from "../../components/MainContainer";
import FundingTable from "./FundingTable";
import { headerDataSettings } from "../../data/modules/settings-header";
import { userDetailContext } from "../../App";
import { hasPrivilege } from "../../utils/privilege";
import { Redirect, useNavigate } from 'react-router-dom';

const useStyles = makeStyles((theme) => ({
  paper: {
    padding: theme.spacing(2),
    display: "flex",
    overflow: "auto",
    flexDirection: "column",
    elevation: 0,
  },
}));

export default function FundingList() {
  const navigate = useNavigate();
  const classes = useStyles();
  const contextData = useContext(userDetailContext);
  useEffect(() => {

  }, []);

  function handleClick() {
    navigate("/funding/add");
  }

  return (
    <MainContainer {...headerDataSettings}>
      <Grid container item xs={12}>
        {hasPrivilege(contextData.privileges, 'Admin-funding-Import') &&
          <Button variant="contained" style={{ fontWeight: 600 }} >IMPORTER</Button>
        } <Spacer x={2} />

        {hasPrivilege(contextData.privileges, 'Admin-funding-Export') &&
          <Button variant="contained" style={{ fontWeight: 600 }} >EXPORTER</Button>
        }<Spacer x={2} />
        {hasPrivilege(contextData.privileges, 'Admin-funding-Add') &&
          <Button variant="contained" color="secondary" onClick={handleClick} style={{ fontWeight: 600 }} >CREER</Button>
        }
      </Grid>
      <Spacer y={2} />
      <Grid container spacing={3}>
        <Grid item xs={12}>
          <Paper className={classes.paper} variant="outlined">
            <FundingTable />
          </Paper>
        </Grid>
      </Grid>
    </MainContainer>
  );
}
